export const DaGridSettings = {
    rowHeight: 32,
    headerRowHeight: 36,
    defaultPageSize: 5,
    rowsPerPageOptions: [5, 10, 25, 50, 100],
}